import React from 'react'

class NoMatch extends React.Component {
    render(){
        return(
            <section className="no-match">
                <p>No Match</p>
            </section>
        )
    }
}

export default NoMatch